import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../../core/authentication/Authentication.service';
import { MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { url } from 'src/app/shared/urls/url';
import { HttpClient } from '@angular/common/http';

// var provider = new firebase.auth.GoogleAuthProvider();
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  Email: string;
  Password: string;
  resultData;
  public activeLang = 'es';

  constructor(private router: Router, private auth: AuthenticationService,
    private _snackBar: MatSnackBar,
    private translate: TranslateService, private http: HttpClient, private user: url) {
    this.translate.setDefaultLang(this.activeLang);
  }

  ngOnInit() {
    localStorage.setItem('language', this.activeLang);
  }

  onSubmitLogin() {
    this.auth.loginEmail(this.Email, this.Password)
      .then((res) => {
        this._snackBar.open('Usuario logeado correctamente.', 'Cerrar', { duration: 3000 });
        this.router.navigate(['/afterlogin']);
      }).catch((err) => {
        switch (err.code) {
          case 'auth/argument-error': {
            this._snackBar.open('Email y contraseña son requeridos', 'Cerrar', {
              duration: 3000
            });
            break;
          }
          case 'auth/wrong-password': {
            this._snackBar.open('Email o contraseña es incorrecta', 'Cerrar', {
              duration: 3000
            });
            break;
          }
          case 'auth/user-not-found': {
            this._snackBar.open('Email o contraseña es incorrecta', 'Cerrar', {
              duration: 3000
            });
            break;
          } default: {
            this._snackBar.open('Error: ' + err.message, 'Cerrar', {
              duration: 3000
            });
            break;
          }
        }
      });
  }

  cambiarLenguaje(event: any) {
    this.activeLang = event.target.value;
    localStorage.setItem('language', this.activeLang);
    this.translate.use(event.target.value);
  }

  onClickGoogleLogin() {
    this.auth.loginGoogle()
      .then((res) => {
        this.router.navigate(['/afterlogin']);
      }).catch(err => console.log(err.message));
  }


}
